module.exports = __webpack_public_path__ + "static/media/quotes.73ab39be.svg";